var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "760"
    },
    on: {
      "click:outside": _vm.cancel
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v("Контакты")]), _c('v-card', {
    staticClass: "border-top",
    staticStyle: {
      "padding": "16px 24px"
    },
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_c('b', [_vm._v("Телефон отдела планирования и организации учебного процесса:")]), _vm._v(" "), _c('span', [_vm._v("303-50-00 доб. 8135, 8133, 8534")]), _c('br'), _c('b', [_vm._v("Режим работы:")]), _vm._v(" 09:00 до 13.00; 13.30-17:30, выходные - суббота, воскресенье"), _c('br'), _c('b', [_vm._v("Заведующий отделом планирования и организации учебного процесса:")]), _vm._v(" Синельникова Милена Валерьевна"), _c('br'), _c('b', [_vm._v("Адрес очной подачи документов:")]), _vm._v(" 195067, Санкт-Петербург, Пискаревский пр., д. 47, 33 пав., 1 этаж, 115 кабинет ")]), _c('v-card-actions', {
    staticClass: "pr-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "lightGrey",
      "text": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" Закрыть ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }